<h2 mat-dialog-title>{{ data.streetName }}</h2>

<mat-dialog-content class="dialog-content">
  <p><strong>Suburb:</strong> {{ data.suburbName }}</p>
  <p><strong>Road type:</strong> {{ data.roadType || 'Not specified' }}</p>
  <p><strong>Houses found:</strong> {{ data.houseCount }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
  <button mat-flat-button color="primary" (click)="viewStreetInfo()">View Street Info</button>
</mat-dialog-actions>
